module.exports = __webpack_public_path__ + "img/icon_point_delete.b07c8bff.svg";